import React, { useMemo } from 'react'
import { useTeamSection } from 'redesign/components/organisms/ShiftPlanSections/TeamSection/useTeamSection'
import EmptyPage from 'redesign/components/organisms/empty-pages'
import { EMPTY_PAGE_VARIANTS } from 'redesign/components/organisms/empty-pages/constants'
import { EmptyPageContainer } from './styles'
import type { ShiftPlanInfoProps } from './types'

const ShiftPlanInfo: React.FC<ShiftPlanInfoProps> = ({
  children,
  showTenantHeadline,
  showEvents,
  isFullyLoaded,
  showShifts,
  canShowEffectiveTimes,
  hasShifts,
  teamPlan,
}) => {
  const { teamsToDisplay } = useTeamSection({ teamPlan })
  const isPageEmpty = useMemo(
    () =>
      isFullyLoaded &&
      !showTenantHeadline &&
      !showShifts &&
      !showEvents &&
      !canShowEffectiveTimes &&
      !hasShifts &&
      !teamsToDisplay.length,
    [
      canShowEffectiveTimes,
      hasShifts,
      isFullyLoaded,
      showEvents,
      showShifts,
      showTenantHeadline,
      teamsToDisplay.length,
    ],
  )

  if (isPageEmpty) {
    return (
      <EmptyPageContainer>
        <EmptyPage variant={EMPTY_PAGE_VARIANTS.noShifts} isCentered />
      </EmptyPageContainer>
    )
  }

  return <>{children}</>
}

export default ShiftPlanInfo
